import OutBoundReferralsTable from 'pages/referrals/OutBoundReferalsTable';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ReferralsTable from '../../referrals/ReferralsTable';

// The engine windows rows and fires infinite scroll against the table's own scroller, so a frame
// that sizes to its rows still needs a ceiling to become one. The floor matters as much: a viewport
// shorter than the subtrahend would otherwise compute a 0px cap and collapse the table outright.
const STACKED_TABLE_MAX_HEIGHT = 'max-h-[max(16rem,calc(100vh-24rem))]';

interface Props {
    contactId?: string;
    contactName: string;
}

const ReferralsView: React.FC<Props> = ({ contactId, contactName }) => {
    if (!contactId) {
        return null;
    }

    return (
        // No height here: the DataTable frame is `height: 100%`, which a definite height would
        // resolve against the whole section — heading and filter chrome included — overrunning it.
        <div className="flex flex-col gap-6">
            <div>
                <h5 className="text-h5">
                    <FormattedMessage id={'referrals.titles.contact-inbound'} />
                </h5>
                <ReferralsTable
                    passiveFilter={`id=isreferralcontact=${contactId}`}
                    contactId={contactId}
                    dataTableClassName={STACKED_TABLE_MAX_HEIGHT}
                />
            </div>

            <div>
                <h5 className="text-h5">
                    <FormattedMessage id={'referrals.titles.contact-outbound'} values={{ client: contactName }} />
                </h5>
                <OutBoundReferralsTable
                    passiveFilter={`id=isoutboundreferral=(${contactId})`}
                    dataTableClassName={STACKED_TABLE_MAX_HEIGHT}
                />
            </div>
        </div>
    );
};

export default ReferralsView;
